const INTERNAL_REFERRAL_CODE_STORAGE_KEY = 'pendingInternalReferralCode'
const REFERRAL_CODE_STORAGE_KEY = 'pendingReferralCode'

export interface PendingReferralCodes {
  internalReferralCode: string | null
  referralCode: string | null
}

export const persistPendingReferralCodes = ({
  internalReferralCode,
  referralCode,
}: {
  internalReferralCode?: string
  referralCode?: string
}): void => {
  if (internalReferralCode) {
    localStorage.setItem(
      INTERNAL_REFERRAL_CODE_STORAGE_KEY,
      internalReferralCode,
    )
  }
  if (referralCode) {
    localStorage.setItem(REFERRAL_CODE_STORAGE_KEY, referralCode)
  }
}

export const readPendingReferralCodes = (): PendingReferralCodes => ({
  internalReferralCode: localStorage.getItem(
    INTERNAL_REFERRAL_CODE_STORAGE_KEY,
  ),
  referralCode: localStorage.getItem(REFERRAL_CODE_STORAGE_KEY),
})

export const clearPendingReferralCodes = (): void => {
  localStorage.removeItem(INTERNAL_REFERRAL_CODE_STORAGE_KEY)
  localStorage.removeItem(REFERRAL_CODE_STORAGE_KEY)
}
